export default __webpack_public_path__ + "static/media/heroku-icon.68909cda.svg";